// @flow

function getEntryFromLocalStorage<T>(key: string): ?T {
  const storage: ?string = localStorage.getItem(key);
  return storage ? JSON.parse(storage) : null;
}

export default getEntryFromLocalStorage;
